import { Component, OnInit, ViewChild,ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../services';
import { Subject, combineLatest } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { AdobeService } from '../../../services/adobe.service';
import { IAMPBulkVIPMigrationViewResponse, IAMPMigratePreviewResponse, IAMPTransferResponse, IAdobeMigrationResponse, IAMPAssociationResponseLineItem, GroupByMembershipID } from '../../../models/amp.model';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { ApiResponse } from '../../../models/api-response.model';
import { FileService } from '../../../services/file.service';
import { AuthService } from '../../../services/auth.service';


@Component({
  selector: 'app-vip-market-place-bulk-migrations',
  templateUrl: './vip-market-place-bulk-migrations.component.html',
  styleUrls: ['./vip-market-place-bulk-migrations.component.css']
})
export class VIPMarketPlaceBulkMigrationsComponent implements OnInit {

  setFullWindow = false;
  title = 'VIP Market Place Bulk Migrations';


  @ViewChild('tabs', { static: false }) tabGroup: MatTabGroup;

  userFormGroup: FormGroup = this.formBuilder.group({
    membershipId: new FormControl("", Validators.compose([Validators.required])),
  });  
  loadContent: boolean = false;
  private resellerId: string;
  programType: string;
  file: any;
  public fileName: string;
  tenantId: string = '';
  selectedPayment: string = '';
  preivewLoading = false;
  disableRequest = false;
  public showTransferButton = false;
  public showNoResult = false;
  bulkGroupOddIndexData = []; 
  public displayedColumns: string[] = [
    'membershipId'
    /* 'stkDesc',
    'offerId',
    'renewalDate',
    'quantity',
    'status' */
  ];
  public inProcessDisplayedColumns: string[] = [
    'transferId',
    'membershipId',
    'creationDate',
    'status'
  ];
  public archiveDisplayedColumns: string[] = [
    'transferId',
    'membershipId',
    'creationDate',
    'status',
    'manageButton'
  ];
  user_validation_messages: any = {
    "membershipId": [
      { class: "membershipIdValidate", message: "Please enter membership ID" }
    ]
  };
  // previewResult: IAMPMigratePreviewResponse[]
  previewResult: IAMPBulkVIPMigrationViewResponse[]
  inProcessResult: IAdobeMigrationResponse[]
  archiveResult: IAdobeMigrationResponse[]
  previewBulkResult: IAMPBulkVIPMigrationViewResponse[]
  ngUnsubscribe: Subject<void> = new Subject<void>();
  bulkGroupData: GroupByMembershipID[]
  

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private adobeService: AdobeService,
    private dialog: MatDialog,
    private fileService: FileService,
    public authService: AuthService
  ) { }

  ngOnInit() {
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
    combineLatest([
      this.adobeService.getCurrentAMPResellerId
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        ([resellerId]) => {
          this.resellerId = resellerId;
        },
        (error: any) => {
          console.error(error);
        }
      );
  }

  transferPreview() {
    this.loadContent = false;
    this.preivewLoading = true;
    const formData = new FormData();
    formData.append(this.file.name, this.file);
    this.adobeService
      .AMPSubscriptionsBulkTransferPreview(formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: IAMPBulkVIPMigrationViewResponse[] | ApiResponse) => {
          this.loadContent = true;
          if ('responseMessage' in res && !(res as ApiResponse)?.status) {
            this.commonService.implementToast(res.responseMessage, 'Error');
          } else {
            this.showTransferButton = true;
            this.previewResult = [...(res as IAMPBulkVIPMigrationViewResponse[])]
            this.previewBulkResult = this.previewResult.reduce((accumulator, value) => accumulator.concat(value), []);
            var validmembershipIdCount = 0;
            for (let i = 0; i < this.previewBulkResult.length; i++) {
              if (this.previewBulkResult[i].status != "Eligible") {
                validmembershipIdCount++;
              }
            }
           /*  if (this.previewBulkResult.length == validmembershipIdCount) {
              this.showTransferButton = false;
              this.commonService.implementToast('Please upload the file with valid membership IDs to migrate', 'Error');
            } */
            var groupData = this.previewBulkResult.reduce((result: any, currentvalue: any) => {
              (result[currentvalue['membershipId']] = result[currentvalue['membershipId']] || []).push(currentvalue);
              return result;
            }, {});

            this.bulkGroupData = Object.keys(groupData).map(key => ({
              membershipId: key,
            }))

            this.bulkGroupOddIndexData = [];
            for (let i = 0; i < this.bulkGroupData.length; i++) {
              if (i % 2 !== 0) {
                this.bulkGroupOddIndexData.push(this.bulkGroupData[i].membershipId);
              }
            }
            if (!this.previewResult.length) this.showNoResult = true
          }
        },
        (error: any) => {
          this.commonService.implementToast(error, 'Error');
        },
        () => {
          this.preivewLoading = false
        }
      );

  }

  isHighlight(membershipId: string) {
    for (let i = 0; i <= this.bulkGroupOddIndexData.length; i++) {
      const result = this.bulkGroupOddIndexData.some(i => i == membershipId);
      return {
        'highlight': result
      }
    }
    return {
      'highlight': false,
    };
  }

  onSelectFile(event): void {
    //this.resetPage();
    this.loadContent = false;
    this.file = event.target.files[0];
    this.fileName = this.file?.name;
    //this.previewBulkResult = [];
    this.loadContent = true; 
  }

  allowDrop(ev) {
    ev.preventDefault();
  }
  drop(ev) {
    this.loadContent = false;

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      [...ev.dataTransfer.items].forEach((item, i) => {
        // If dropped items aren't files, reject them
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.file = file
          this.fileName = this.file.name;
          //this.resultTableDataSrc = [];
        }        
      });
    }
    this.loadContent = true;
  }
  
  downloadSampleFile(): void {
    this.loadContent = false;
    this.fileService.saveFile('Sample_Migration_File.xlsx').subscribe(res => {
      this.fileService.saveAsExcelFile(res, 'Sample_Migration_File.xlsx');
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }
  isNotValidField(path: string, validation: any): void {
    if (path == "requestedBy") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  goToCustomer(e: IAdobeMigrationResponse) {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP/AMPDetails/' + e.customerId);
  }

  transferSubscriptions() {   
    this.loadContent = false;
    this.preivewLoading = true;
    this.disableRequest = true;
    const formData = new FormData();
    formData.append(this.file.name, this.file);
    this.adobeService
      .AMPBulkTransferSubscriptions(this.resellerId, formData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: IAMPTransferResponse) => {    
          this.loadContent = true;     
          this.commonService.implementToast('Eligible market place subscriptions submitted successfully for migration', 'Success');
          this.resetPage();
          this.tabGroup.selectedIndex = 1
        },
        (error: any) => {
          console.error(error);
        },
        () => {
          this.preivewLoading = false;
          this.disableRequest = false;
        }
      );
  }
  
  public resetPage(): void {
    this.preivewLoading = false;
    this.disableRequest = false;
    this.previewResult = [];
    this.showTransferButton = false;
    this.file.value = '';
    this.fileName = '';
    const fileInput = <HTMLInputElement>document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';  // Reset the input value
    }    
  }

  myTabSelectedTabChange(event: MatTabChangeEvent) {
    const tabName = event.tab.textLabel;
    if (tabName == 'In-Process' || tabName == 'Archive') {
      this.preivewLoading = true;
      this.adobeService.getAdobeMigrationData(tabName).subscribe((res: IAdobeMigrationResponse[]) => {
        if (tabName == 'In-Process') {
          this.inProcessResult = res
        }
        if (tabName == 'Archive') {
          this.archiveResult = res
        }
        this.preivewLoading = false;
      },
        (error: any) => {
          console.error(error);
          this.preivewLoading = false;
          this.disableRequest = false;
        });
    }
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP');
  }
}
